// extracted by mini-css-extract-plugin
export default {"Quiz":"Quiz_Quiz__DeWTQ","QuizWrapper":"Quiz_QuizWrapper__sENfh"};